<div class="h-100 p-2" *ngIf="availableSpells">
  <h5>Based on the class you chose, you get {{cantrips}} cantrips and {{spellsKnown}} 1st level spells.
    Choose your spells from the list of {{_class}} spells below.</h5>

  <div class="d-flex justify-content-between h-100 w-100 mt-1">
    <div class="custom-scrollbar border p-2" style="width: 49%; height: 94%;">
      <h3 class="text-center mb-1">{{_class}} Spells</h3>
      <app-spell [spells]="availableSpells" [characterCreate]="true" (addedSpell)="addSpell($event)"></app-spell>
    </div>
    <div class="custom-scrollbar border p-2" style="width: 49%; height: 94%">
      <h3 class="text-center mb-1">Selected Spells</h3>
      <div *ngIf="addedCantrips && addedSpells" class="d-flex flex-column">
          <h3>Cantrips</h3>
          <div *ngFor="let cantrip of addedCantrips" class="card w-100 mt-1" style="height: 45px"
               [ngClass]="cantrip.name ? 'bg-white' : 'bg-light'"><strong class="ml-2 my-auto">{{cantrip.name}}</strong>
          </div>
          <h3 *ngIf="spellsKnown > 0" class="mt-2">Level 1</h3>
          <div *ngFor="let spell of addedSpells" class="card w-100 mt-1" style="height: 45px"
               [ngClass]="spell.name ? 'bg-white' : 'bg-light'"><strong class="ml-2 my-auto">{{spell.name}}</strong>
          </div>
      </div>
    </div>
  </div>
</div>
